import { CLOSE_DRAWER, OPEN_DRAWER } from "../actions/DrawerTypes";

const INITIAL_STATE = {
    showDrawer: true,
}

export default (state = INITIAL_STATE, action) => {

    switch (action.type) {

        case CLOSE_DRAWER:
            return { showDrawer: false }

        case OPEN_DRAWER:
            return { showDrawer: true }

        default: return state;

    }
}
